const GuestBadge = () => (
  <span className="flex items-center justify-center rounded-full bg-oxford-gray-500 text-white text-2xs w-4 h-4 flex-shrink-0">
    G
  </span>
)

export default GuestBadge
